import numeral from 'numeral';
export var MathOperations;
(function (MathOperations) {
    MathOperations["add"] = "add";
    MathOperations["subtract"] = "subtract";
    MathOperations["multiply"] = "multiply";
    MathOperations["divide"] = "divide";
})(MathOperations || (MathOperations = {}));
export var formatNumber = function (value, formatString, operationType, operationValue) {
    var availableOperations = Object.values(MathOperations);
    var valueToFormat = value;
    if (operationType &&
        availableOperations.includes(operationType) &&
        !isNaN(operationValue)) {
        valueToFormat = applyMathOperation(value, operationType, operationValue);
    }
    return numeral(valueToFormat).format(formatString);
};
var applyMathOperation = function (value, operationType, operationFactor) {
    var output = value;
    switch (operationType) {
        case MathOperations.add:
            output += operationFactor;
            break;
        case MathOperations.subtract:
            output -= operationFactor;
            break;
        case MathOperations.divide:
            output /= operationFactor;
            break;
        case MathOperations.multiply:
            output *= operationFactor;
            break;
        default:
            break;
    }
    return output;
};
